// src/pages/docs/overwatch/info.jsx
import { Typography, Box, Link, Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const TeamCommand = () => {
  const location = useLocation();
  const command = commandList.find((cmd) => cmd.path === location.pathname);
  const { prev, next } = getAdjacentCommands(location.pathname);

  return (
    <DocsLayout>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth: 900 }}>
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            {"/옵치 내전"}
          </Typography>
          <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
          {command?.description ?? '설명이 없습니다.'}<br />
            <Link
                href="/docs/overwatch/owregister"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: '#5ec8f2' }}
            >
                /옵치 등록
            </Link>으로 배틀태그 정보가 등록되어 있어야 합니다.
          </Typography>
          <Typography variant="h6">
            {"사용법: /옵치 내전 [제외]"}<br />{"[]는 선택 사항입니다."}
          </Typography>
          <Typography variant="body1" sx={{ mt: 3}}>
          {"예시: /옵치 내전 [@티칩]"}<br />{"[제외]를 선택하면 지정한 플레이어를 제외하고 팀을 구성합니다."}<br /><br />
          {"1. 내전할 플레이어 10명 모두 "}
          <Link
                href="/docs/overwatch/owregister"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: '#5ec8f2' }}
            >
                /옵치 등록
            </Link>{" 명령어를 사용하여 자신의 배틀태그를 등록해야 합니다."}<br />

          {"2. "}<Link
                href="/docs/overwatch/tier"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: '#5ec8f2' }}
            >
                /옵치 티어
            </Link>{" 또는 "}
            <Link
                href="/docs/overwatch/info"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: '#5ec8f2' }}
            >
                /옵치 정보
            </Link>{" 명령어를 사용하여 봇에 저장된 전적 정보를 업데이트합니다.(선택)"}<br />
          {"3. 내전할 플레이어 10명이 같은 음성방에 접속합니다."}<br />
          {"4. 그 후, /옵치 내전 명령어를 사용합니다."}<br />
          </Typography>          
        </Box>

        {/* 오른쪽 이미지 영역 */}
        <Box
          component="img"
          src="/commands/team.png"
          alt="설명 이미지"
          sx={{
            width: '100%',
            maxWidth: 400,
            borderRadius: 2,
            flexShrink: 0,
            mx: 'auto',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'space-between' },
            gap: 4,
            width: { xs: '100%',md: 'auto' },
          }}
        >
        {prev && (
          <Button href={prev.path} variant="outlined"sx={{height: 36, width:118 }}>
            ← {prev.name}
          </Button>
        )}
        {next && (
          <Button href={next.path} variant="outlined"sx={{height: 36, width:118 }}>
            {next.name} →
          </Button>
        )}
        </Box>
      </Box>
    </DocsLayout>
  );
};

export default TeamCommand;
